import { render, staticRenderFns } from "./TaxonomyElementSelect.vue?vue&type=template&id=24fd28ac&scoped=true&"
import script from "./TaxonomyElementSelect.vue?vue&type=script&lang=js&"
export * from "./TaxonomyElementSelect.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyElementSelect.vue?vue&type=style&index=0&id=24fd28ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd28ac",
  null
  
)

export default component.exports